import { render, staticRenderFns } from "./DeliveryLoadHistoryDetail.vue?vue&type=template&id=727e04e5&"
import script from "./DeliveryLoadHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./DeliveryLoadHistoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports